import {miraApi} from '@mira/api';
import {configureStore} from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    [miraApi.reducerPath]: miraApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(miraApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
